<template>
  <FormPanel
      headline="Create Search Suggestion"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/SearchSuggestions/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/search-suggestions', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The search suggestion was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/search-suggestions')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
